import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

const keyOf = (product, variant) => `${product.id}|${variant || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("gb-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("gb-cart", JSON.stringify(items));
  }, [items]);

  const add = (product, variant = "", addons = []) => {
    const key = keyOf(product, variant);
    setItems((prev) => {
      const found = prev.find((p) => p.key === key);
      if (found) {
        return prev.map((p) => (p.key === key ? { ...p, qty: p.qty + 1 } : p));
      }
      return [...prev, { ...product, key, variant, addons, qty: 1 }];
    });
    setOpen(true);
  };

  const setQty = (key, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((p) => p.key !== key));
    } else {
      setItems((prev) => prev.map((p) => (p.key === key ? { ...p, qty } : p)));
    }
  };

  const remove = (key) => setItems((prev) => prev.filter((p) => p.key !== key));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((s, p) => s + p.qty, 0);
    const subtotal = items.reduce((s, p) => s + p.qty * (p.price || 0), 0);
    return { items, add, setQty, remove, clear, count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
